export default {
  methods: {
    keyValues(pkg) {
      return [
        {
          label: 'Version',
          value: `${pkg.major}.${pkg.minor}.${pkg.build}`,
        },
      ];
    },
  },
};
